import React, { memo } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { CardView, Spacer } from 'design-system';
import AllocationSlider from 'design-system/AllocationSlider';
import EmojiText from 'design-system/EmojiText';
import IconCircle from 'design-system/icons/IconCircle';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useStyles from 'hooks/useStyles';
import { selectUserTier } from 'features/premium/selectors/tier';
import createStyleSheets from 'utils/createStyleSheets';
const DistributionCard = ({ name, percent, emoji, maximumValue, onPercentageChange, onSlidingStart, onSlidingComplete, productName, productTierRates, testID, }) => {
    const userTier = useAppSelector(selectUserTier);
    const { width } = useAppFrameDimensions();
    const styles = useStyles(styleSet);
    const productRate = productTierRates?.find((r) => r.tier === userTier);
    return (<CardView noMarginTop style={styles.card}>
      <View style={styles.header}>
        <IconCircle width={rem(44)} height={rem(44)}>
          {emoji ? <EmojiText>{emoji}</EmojiText> : <IconEmmaWallet />}
        </IconCircle>
        <View style={styles.titleContainer}>
          <Text Text-16>{name}</Text>
          {productName ? (<Text TextThin-14 Secondary>
              {productName}
            </Text>) : null}
          {!!productRate && (<Text NumbersThin-14 Secondary>
              {productRate.rate.toFixed(2)}% AER
            </Text>)}
        </View>
        <Text Numbers-16>{parseFloat(percent.toFixed(2))}%</Text>
      </View>
      <Spacer h={8}/>
      <AllocationSlider testID={testID} value={percent} sliderWidth={width - rem(64)} accessibilityLabel={`${name} allocation`} maximumValue={maximumValue} onValueChange={onPercentageChange} onSlidingStart={onSlidingStart} onSlidingComplete={onSlidingComplete}/>
    </CardView>);
};
const styleSet = createStyleSheets(() => ({
    card: {
        paddingHorizontal: rem(16),
        paddingVertical: rem(16),
        paddingBottom: rem(8),
    },
    header: {
        gap: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleContainer: {
        flex: 1,
    },
}));
export default memo(DistributionCard);
